/**
 * RunTicketHeading - a run's ticket identifier (linked when it has a URL)
 * with a button that copies the ticket, PR links and total cost
 */

import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { CopyRunSummaryButton } from './CopyRunSummaryButton';

interface RunTicketHeadingProps {
  ticketKey: string;
  ticketUrl: string | null;
  prUrls: string[];
  /** Only known for admins */
  totalCostCents?: number;
}

export function RunTicketHeading({
  ticketKey,
  ticketUrl,
  prUrls,
  totalCostCents,
}: RunTicketHeadingProps) {
  return (
    <div className="flex items-center gap-2">
      {ticketUrl ? (
        <Link
          to={ticketUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg font-bold text-gray-900 dark:text-white hover:text-indigo-600 dark:hover:text-indigo-400 flex items-center gap-2"
        >
          {ticketKey}
          <ExternalLink className="w-4 h-4" />
        </Link>
      ) : (
        <h1 className="text-lg font-bold text-gray-900 dark:text-white">{ticketKey}</h1>
      )}
      <CopyRunSummaryButton
        ticketKey={ticketKey}
        ticketUrl={ticketUrl}
        prUrls={prUrls}
        totalCostCents={totalCostCents}
      />
    </div>
  );
}
